// extracted by mini-css-extract-plugin
export default {"container":"Tile-module__container__Js8Dt","selected":"Tile-module__selected__RM8K8","label":"Tile-module__label__z8+oo"};